import mixpanel from "mixpanel-browser";

export class Mixpanel {
  static identify(userId: string) {
    try {
      mixpanel.identify(userId);
    } catch (error) {
      console.error(error);
    }
  }

  static setPersonProperties(properties: any) {
    try {
      mixpanel.people.set(properties);
    } catch (error) {
      console.error(error);
    }
  }

  static track(event: string, properties: any) {
    try {
      mixpanel.track(event, properties);
    } catch (error) {
      console.error(error);
    }
  }

  static reset() {
    try {
      mixpanel.reset();
    } catch (error) {
      console.error(error);
    }
  }
}
